import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
// import component
import ButtonGroup from '../elements/CardButtonGroupWithLinkProp';

const DataProcessingSessionButtons = (props) => {
  return(
    <ButtonGroup list={props.list.content}/>
  )
}

export default DataProcessingSessionButtons;